import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { IMasterCode, IMCT, IMC } from '../dto/MasterCode';

@Module({ dynamic: true, store, name: 'masterCode', namespaced: true })
class MasterCode extends VuexModule implements IMasterCode {
    // state
    /**
     * @state
     * データ移動状態
     */
    moveState = '0';

    /**
     * @state
     * コード表情報
     */
    masterCode: IMCT = {
        startDate: '',
        businessTypeCodeNo: '',
        codeTableNo: '',
    };

    /**
     * @state
     * コード情報
     */
    masterCode2: IMC = {
        startDate: '',
        businessType: '',
        codeTableNo: '',
        codeNo: '',
    };

    // getter
    /**
     * @Getter
     * パスの取得
     */
    get GET_PATH() {
        return `/${this.masterCode.startDate}/${this.masterCode.businessTypeCodeNo}/${this.masterCode.codeTableNo}`;
    }

    /**
     * @Getter
     * 移動状況の確認
     */
    get CHECK_MOVE_STATE() {
        if (this.moveState === '1') {
            return true;
        }
        return false;
    }

    /**
     * @Getter
     * パスの取得
     */
    get GET_PATH2() {
        return `/${this.masterCode2.startDate}/${this.masterCode2.businessType}/${this.masterCode2.codeTableNo}/${this.masterCode2.codeNo}`;
    }

    // action
    /**
     * @Action
     * コード表情報の保管
     * @param param (IMCT)コード表
     */
    @Action({})
    public setCodeTable(param: IMCT) {
        this.SET_IMCT(param);
    }

    /**
     * @Action
     * 登録画面移動時のフラグ変更
     */
    @Action({})
    public transferToInfo() {
        this.TRANSFER_TO_INFO();
    }

    /**
     * @Action
     * 登録画面到着時のフラグ変更
     */
    @Action({})
    public arrivalToInfo() {
        this.ARRIVAL_TO_INFO();
    }

    /**
     * @Action
     * コード表情報の保管
     * @param param (IMCT)コード表
     */
    @Action({})
    public setCodeTable2(param: IMC) {
        this.SET_IMC(param);
    }

    @Action({})
    public moduleReset() {
        this.MODUEL_RESET();
    }

    // mutation
    /**
     * @Mutation
     * コード表情報の保管
     * @param param (IMCT)コード表
     */
    @Mutation
    private SET_IMCT(param: IMCT) {
        this.masterCode = param;
    }

    /**
     * @Mutation
     * 登録画面移動時のフラグ変更
     */
    @Mutation
    private TRANSFER_TO_INFO() {
        this.moveState = '1';
    }

    /**
     * @Mutation
     * 登録画面到着時のフラグ変更
     */
    @Mutation
    private ARRIVAL_TO_INFO() {
        this.moveState = '0';
    }

    /**
     * @Mutation
     * コード情報の保管
     * @param param (IMC)コード表
     */
    @Mutation
    private SET_IMC(param: IMC) {
        this.masterCode2 = param;
    }

    @Mutation
    private MODUEL_RESET() {
        this.moveState = '0';
        this.masterCode = {
            startDate: '',
            businessTypeCodeNo: '',
            codeTableNo: '',
        };
        this.masterCode2 = {
            startDate: '',
            businessType: '',
            codeTableNo: '',
            codeNo: '',
        };
    }

}

export const masterCodeModule = getModule(MasterCode);
